export default import.meta.ROLLDOWN_FILE_URL_1oV7xAXKZMql0H3IJxU8wQ